<script setup>

import {useRoute} from "vue-router";
import {storeToRefs} from "pinia/dist/pinia";
import {ref} from "vue";
import {useExerciseStore} from "@/stores/exercise.store";

const route = useRoute();
const exerciseStore = useExerciseStore();

exerciseStore.fetchOne(route.params.id);
const {exercise} = storeToRefs(exerciseStore);
const name = ref(1);

const toggleUserResource = async () => {
  await exerciseStore.toggleUserResource(route.params.id);
}

</script>

<template>
  <van-form>
    <van-cell-group inset>
      <van-collapse v-model="name" accordion>
        <van-collapse-item name="1">
          <template #title>
            <b>{{ exercise.name }}</b>
          </template>
          <template #value>
            <van-tag round plain size="medium" type="success">
              <van-icon v-if="exercise.user_exercise_id != null" type="primary" name="star"/>
              <van-icon v-else type="primary" name="star-o"/>
            </van-tag>
          </template>
          {{ exercise.description }}
        </van-collapse-item>
      </van-collapse>
      <span v-if="exercise.user_treatment_session_id != null">
      <van-cell title="My Session" is-link :value="exercise.treatment_session_name"
                :to="'/session/' + exercise.user_treatment_session_id"/>
      <van-cell title="My Exercise" is-link :to="'/exercise/' + exercise.user_exercise_id"/>
    </span>
      <van-cell title="Created By" :value="exercise.created_by_user"/>
      <van-cell title="Created" :value="exercise.created_at_formatted"/>
    </van-cell-group>

    <van-divider/>

    <van-cell-group inset>
      <iframe width="100%" height="400" :src="exercise.source_url"
              title="YouTube video player" frameborder="0"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
              allowfullscreen>
      </iframe>
    </van-cell-group>

    <van-divider/>

    <van-cell-group inset>
    <span v-if="exercise.user_treatment_session_id == null">
      <van-button v-if="exercise.user_exercise_id == null" block round type="success" @click="toggleUserResource">
        Add to My Exercise
      </van-button>
      <van-button v-else block round type="success" @click="toggleUserResource">
        Remove from My Exercise
      </van-button>
    </span>
    </van-cell-group>
  </van-form>

</template>
